// extracted by mini-css-extract-plugin
export default {"is_hidden":"c55e81","is_hidden__hidden":"e1b7a2"};